import {UnexpectedState} from './states/UnexpectedState';
import {UnexpectedStateController} from './controllers/unexpectedStateController';
import './unexpected.css';

let appModule = angular.module('deliveryCreate.app');
appModule.controller('UnexpectedStateController', UnexpectedStateController);
appModule.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {
    $stateProvider.state(UnexpectedState);
}]);


/** WEBPACK FOOTER **
 ** ./DeliveryCreate/UI/app/features/unexpected/bootstrap.ts
 **/